import { combineReducers } from "redux";
import dropdown from "./dropdowns/DropdownReducer";
export default combineReducers({
    dropdown
})